/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
class o{constructor(o){this.elevationInfo=o}}export{o as SnappingHint};
